const POPULATIONS = [
  ["FULL_ACCIDENTS", "41 131", "KPI, динамика и описательная статистика."],
  ["ANALYTICAL_MATCHED", "40 918", "Погода, гипотезы и модели тяжести."],
  ["ROAD H3 2024", "106 517", "Область пространственного моделирования."],
  ["FULL H3 2024", "185 911", "Полный пространственный реестр."],
];

const CHECKPOINTS = [
  ["Все ДТП", "8 901"],
  ["ДТП с пострадавшими", "8 652"],
  ["Смертельные ДТП", "326"],
  ["С пострадавшими детьми", "1 180"],
  ["С погибшими детьми", "12"],
];

const TERM_GROUPS = [
  [
    ["ДТП с пострадавшими", "Количество ДТП, где был хотя бы один пострадавший. Это не число пострадавших людей."],
    ["Смертельное ДТП", "Количество ДТП с хотя бы одним погибшим. Это не всегда равно числу погибших лиц."],
    ["Odds ratio", "Скорректированная или нескорректированная ассоциация; не причинный эффект."],
    ["FDR", "Поправка на множественные сравнения, основной критерий статистической значимости."],
  ],
  [
    ["Прогнозный риск H3", "Ожидаемая частота или вероятность при данных признаках, не гарантия ДТП."],
    ["NON_ROAD", "Вне области дорожного моделирования, а не территория без риска."],
    ["Local Moran HH", "Высокий риск, окружённый высоким риском."],
    ["Остаточная автокорреляция", "Сигнал неучтённой пространственной структуры после модели."],
  ],
];

const LIMITATIONS = [
  "Статистическая связь не означает причинность.",
  "Отрицательная ассоциация не означает защитный эффект.",
  "Редкие категории могут иметь нестабильные доли и широкие доверительные интервалы.",
  "Модели тяжести условны относительно уже произошедшего ДТП.",
  "Погодные признаки зависят от ближайшей станции и временного сопоставления.",
  "Интерактивные фильтры HTML не пересчитывают статистические тесты или модели.",
  "Прогнозы 2024 года нельзя переносить на другие годы без обновления признаков и проверки качества.",
  "Пространственные folds неодинаковы по числу ДТП, что делает spatial CV консервативной.",
];

const PARAMETERS = [
  ["Аналитические совокупности", "Полная совокупность ДТП", "41 131 ДТП", "Используется для KPI, динамики и описательной статистики."],
  ["Аналитические совокупности", "Интегрированная аналитическая совокупность", "40 918 ДТП", "Используется для гипотез, погодных и severity-моделей."],
  ["Аналитические совокупности", "Картографическая совокупность", "2024 год", "Используется для частотных моделей, Global/Local Moran и карты."],
  ["Период и покрытие", "Период исходных ДТП", "2020–2024", "Основной исторический период анализа."],
  ["Картографический слой", "Основной год карты", "2024", "Год прогнозов и локальной статистики."],
  ["Картографический слой", "Разрешение H3", "10", "Пространственная сетка итоговой карты."],
  ["Картографический слой", "Система координат", "EPSG:4326", "Географическая система координат GeoParquet."],
  ["Проверка гипотез", "Уровень значимости", "0.05", "Базовый уровень значимости."],
  ["Проверка гипотез", "Коррекция множественных сравнений", "Benjamini–Hochberg FDR", "Основной критерий итоговой значимости."],
  ["Пространственная статистика", "Перестановки Local Moran", "999", "Количество перестановок."],
  ["Модели частоты ДТП", "Основная count-модель", "NB2_negative_binomial_full_primary", "Модель годового числа ДТП."],
  ["Модели частоты ДТП", "Основная binary-модель", "L2_logistic_full_primary", "Модель вероятности хотя бы одного ДТП."],
  ["Пострадавшие и погибшие", "Смысл injury-показателя", "Количество ДТП с пострадавшими", "Не равно числу пострадавших людей."],
  ["Обнаруженные исходные поля", "full_year", "source_year", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_date", "accident_datetime", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_month", "month", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_accident_id", "accident_id", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_hex_id", "—", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_fatal", "fatal_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_injury", "injured_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_child_fatal", "child_fatal_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_child_injury", "child_injured_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_fatal_people", "—", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "full_injured_people", "—", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_year", "source_year", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_date", "accident_datetime", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_month", "month", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_accident_id", "accident_id", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_hex_id", "hex_id", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_fatal", "fatal_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_injury", "injured_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_child_fatal", "child_fatal_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_child_injury", "child_injured_flag", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_fatal_people", "—", "Поле, обнаруженное в accident-level parquet."],
  ["Обнаруженные исходные поля", "matched_injured_people", "—", "Поле, обнаруженное в accident-level parquet."],
];

export default function MethodologyReportSection() {
  return (
    <section className="statistics-methodology-report">
      <header className="statistics-methodology-hero">
        <h2>Методология, качество данных и правила интерпретации</h2>
        <p>Эта страница объясняет, из каких совокупностей построены разделы, чем отличаются показатели ДТП и пострадавших, почему используются FDR и пространственная валидация и какие ограничения необходимо учитывать заказчику.</p>
      </header>

      <div className="statistics-methodology-populations">
        {POPULATIONS.map(([code, value, label]) => (
          <article key={code}><h3>{code}</h3><strong>{value}</strong><p>{label}</p></article>
        ))}
      </div>

      <h3 className="statistics-methodology-title">Контрольные значения 2024 года</h3>
      <div className="statistics-methodology-checkpoints">
        {CHECKPOINTS.map(([label, value]) => <article key={label}><span>{label}</span><strong>{value}</strong></article>)}
      </div>

      <h3 className="statistics-methodology-title">Как читать показатели</h3>
      <div className="statistics-methodology-terms">
        {TERM_GROUPS.map((group, index) => (
          <article key={index}>
            {group.map(([term, description]) => <div key={term}><b>{term}</b><span>{description}</span></div>)}
          </article>
        ))}
      </div>

      <h3 className="statistics-methodology-title">Ограничения исследования</h3>
      <article className="statistics-methodology-limits"><ol>{LIMITATIONS.map((item) => <li key={item}>{item}</li>)}</ol></article>

      <h3 className="statistics-methodology-title">Контроль качества поставки</h3>
      <div className="statistics-methodology-quality">
        <article><span>Проверок качества</span><strong>2,990</strong></article>
        <article><span>Положительных статусов</span><strong>46</strong></article>
        <article><p>Поставка прошла контрактную проверку схем core-витрин. Финальный статический отчёт читает только уже подготовленные результаты и не изменяет parquet-файлы.</p></article>
      </div>

      <h3 className="statistics-methodology-title">Параметры исследования</h3>
      <div className="statistics-report-table-wrap statistics-methodology-table-wrap">
        <table className="statistics-report-table statistics-methodology-parameters">
          <thead><tr><th>Раздел</th><th>Параметр</th><th>Значение</th><th>Описание</th></tr></thead>
          <tbody>{PARAMETERS.map(([section, parameter, value, description]) => <tr key={parameter}><td>{section}</td><td>{parameter}</td><td>{value}</td><td>{description}</td></tr>)}</tbody>
        </table>
      </div>
    </section>
  );
}
